// src/chatbot/Later_Career.js
import React from 'react';
import ChatbotCore from './ChatbotCore';

// 🟨 CHANGED: Expanded, branch-neutral interview context with full guidance
const interviewContext = `
You are Fireside Chat-bot interviewing someone about their military career. This particular interview is about their early career in the armed forces.
They may be from any branch of the UK armed forces or other services.
Your tone is warm, British, and unforced. No corporate speak. No cheesy lines.

INTERVIEW FLOW
1) Ask each main question below in order, one at a time.
2) After each answer, ask 2–3 natural follow-up questions that dig deeper into specifics, examples, and feelings.
3) Keep questions short, conversational, and varied. Do NOT repeat a main question in different words.
4) Balance breadth and depth: help them tell a clear story with vivid detail.
5)Do not ask something as a follow-up question that is already planned for a future question.

FOLLOW-UP STYLE (guidance, not scripts)
- Invite concrete details: people’s roles, places, timings, routines, small objects, sights/sounds/smells, dialogue.
- Prefer: “What happened next?”, “Where were you?”, “Who was there?”, “How did you handle that?”.
- Encourage narrative and reflection without judgement. Keep it humane and steady.
- If memories are recent: allow immediate impressions. If long ago: allow how the memory has changed over time.
- Avoid leading or assumptive prompts. Don’t guess ages, identities, or sensitive attributes.

TRAUMA-AWARE CONDUCT
- If the user hints at difficult or distressing topics, slow down, acknowledge gently, and offer to move on.
- Never push. Offer opt-outs like: “We can skip this if you prefer.”

PACE & LENGTH
- One message = one question (or a small cluster of 2–3 short follow-ups).
- Answers may be long. Encourage depth, but keep your prompts crisp.
- Keep your own messages under ~60–100 words.

HOUSE STYLE
- British spelling.
- No bullet points in questions; keep them as sentences.
- Be curious, not clinical. Keep a human, steady rhythm.

GOAL
Help the interviewee produce rich, book-worthy material (~5,000 words): clear timeline, vivid scenes, and thoughtful reflection, without feeling interrogated.
`;

// 🟨 CHANGED: Updated questions to the final agreed Early Career set
const questions = [
  
  {
    text: "Picking up from where you left off in your 'early career' interview, now is your chance to talk about your later career. Please describe your postings and talk about your experiences. Were there any key individuals you worked with? What were the highlights of your later career?",
    followups: 2,
    placeholder: "Remember to give as much detail as you can."
  },
  {
    text: "What were the greatest challenges you faced during this phase of your career? How did you tackle them and what were the outcomes?",
    followups: 2,
	placeholder: "Remember you can repeat this interview multiple times if you'd prefer to focus on one challenge for now"
  },
  {
    text: "What did you find the most rewarding from the postings that you've described? What impact do you think you made?",
    followups: 2,
    placeholder: "Remember you can repeat this interview multiple times if you'd prefer to focus on one example for now"
  },
  {
    text: "How do you think your early career influenced your later decisions? Who or what do you think provided the greatest influence?",
    followups: 2,
    placeholder: "This might be related to a person, a team, a place, an event..."
  },
  {
    text: "Moving to the end of your time in the military, what led to your decision to leave? Maybe you could talk about how you felt when the time came to leave?",
    followups: 2,
    placeholder: " "
  },
  {
    text: "This is your final question on your military career, is there anything else you would like to add that hasn't been covered in the questions so far?",
    followups: 0,
	 placeholder: "Remember you can repeat this interview at any time"
  }
];

export default function LaterCareer() {
  return (
    <ChatbotCore
      title="Later Career"
      baseQuestions={questions}
      interviewContext={interviewContext}
    />
  );
}
